export const addTitlePage = (title) => {
  document.title = title + ' - Studio Mou'
}